import { Component, OnInit, Input } from '@angular/core';
import { NoDataTypes, NoDataSourceType, NoDataActionType } from '../../interfaces/no-data';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';

interface NoDataProperty {
    action: NoDataActionType;
    inputSource: NoDataSourceType;
    image: string;
    bodyMessage: Array<string>;
    header: string;
}

@Component({
    selector: 'no-data-screen',
    templateUrl: './no-data-screen.component.html',
    styleUrls: ['./no-data-screen.component.scss'],
})
export class NoDataScreenComponent implements OnInit {
    constructor(private reusableFunctions: ReusableFunctions) {}

    @Input() logoPlaceholderMain?: string = 'src/assets/images/no_data_images/';
    @Input() noDataType: NoDataTypes;
    headerMessage: string;
    bodyMessage: Array<string>;
    cardStyle: string;
    logoPlaceholderPath: string;
    noDataTypeList: NoDataProperty[];
    showTitle: boolean;
    componentTitle: string;
    showImage: boolean;
    noDataHeaderMessage: string;
    customMessage: string;

    ngOnInit() {
        this.cardStyle = 'no-data-card-area-with-no-card';
        let tryAgainMessage = ['Try changing your filters and searching again.'];
        let searchSomethingElse = ['Try searching for something else.'];
        let headerDynamicText = 'No Results Found for "$[replaceTextHeader]"';
        let bodyDynamicText = ['Your $[replaceTextBody] will appear here.'];
        let dynamicHeaderEmptyState = 'No $[replaceTextHeader] Selected';
        let dynamicBodyEmptyState = [
            'Select a $[replaceTextHeader] in the Display Options $[replaceTextBody].',
        ];
        let noData = this.noDataType.noDataTitleCustomMessage ?? 'No Data Available';
        let noResult = this.noDataType.noDataTitleCustomMessage ?? 'No Results Found';
        let errorHeader = "Oops! Something's Not Right";
        let errorMessage = [
            'Refresh the page or log in again.',
            'If this keeps happening, please contact support.',
        ];
        let loockHeader = 'Access Restricted';
        let lockMessage = [
            'You don’t have permission to view this data.',
            'Contact your nCino Mortgage Analytics administrator for details.',
        ];
        let message = ['Try changing your filters and searching again.'];
        let noDataCategories: NoDataProperty[];
        let noDataInfo: NoDataProperty;
        this.customMessage = this.noDataType.noDataCustomMessage ?? '';
        this.showTitle = false;
        this.componentTitle = '';
        this.showImage = true;
        this.noDataHeaderMessage = 'no-data-header-message-all-other';

        this.noDataTypeList = [
            {
                action: NoDataActionType.pageStart,
                inputSource: NoDataSourceType.chartCard,
                image: 'empty_chart_data_img',
                header: noResult,
                bodyMessage: bodyDynamicText,
            },
            {
                action: NoDataActionType.pageStart,
                inputSource: NoDataSourceType.table,
                image: 'empty_table_data_img',
                header: noResult,
                bodyMessage: bodyDynamicText,
            },
            {
                action: NoDataActionType.pageStart,
                inputSource: NoDataSourceType.largeDataCard,
                image: 'empty_table_data_img',
                header: noResult,
                bodyMessage: bodyDynamicText,
            },
            {
                action: NoDataActionType.emptySelect,
                inputSource: NoDataSourceType.largeDataCard,
                image: 'empty_table_data_img',
                header: dynamicHeaderEmptyState,
                bodyMessage: dynamicBodyEmptyState,
            },
            {
                action: NoDataActionType.pageStart,
                inputSource: NoDataSourceType.smallDataCard,
                image: 'empty_table_data_img',
                header: noResult,
                bodyMessage: bodyDynamicText,
            },
            {
                action: NoDataActionType.pageStart,
                inputSource: NoDataSourceType.verySmallDataCard,
                image: '',
                header: noResult,
                bodyMessage: bodyDynamicText,
            },
            {
                action: NoDataActionType.search,
                inputSource: NoDataSourceType.table,
                image: 'empty_search_results_img',
                header: headerDynamicText,
                bodyMessage: searchSomethingElse,
            },
            {
                action: NoDataActionType.filter,
                inputSource: NoDataSourceType.table,
                image: 'empty_filter_results_img',
                header: noResult,
                bodyMessage: tryAgainMessage,
            },
            {
                action: NoDataActionType.filter,
                inputSource: NoDataSourceType.chartCard,
                image: 'empty_filter_results_img',
                header: noResult,
                bodyMessage: tryAgainMessage,
            },
            {
                action: NoDataActionType.filter,
                inputSource: NoDataSourceType.largeDataCard,
                image: 'empty_filter_results_img',
                header: noResult,
                bodyMessage: tryAgainMessage,
            },
            {
                action: NoDataActionType.filter,
                inputSource: NoDataSourceType.smallDataCard,
                image: 'empty_filter_results_img',
                header: noResult,
                bodyMessage: tryAgainMessage,
            },
            {
                action: NoDataActionType.filter,
                inputSource: NoDataSourceType.verySmallDataCard,
                image: '',
                header: noResult,
                bodyMessage: tryAgainMessage,
            },
            {
                action: NoDataActionType.error,
                inputSource: NoDataSourceType.table,
                image: 'Empty-State-Error',
                header: errorHeader,
                bodyMessage: errorMessage,
            },
            {
                action: NoDataActionType.error,
                inputSource: NoDataSourceType.largeDataCard,
                image: 'Empty-State-Error',
                header: errorHeader,
                bodyMessage: errorMessage,
            },
            {
                action: NoDataActionType.error,
                inputSource: NoDataSourceType.smallDataCard,
                image: 'Empty-State-Error',
                header: errorHeader,
                bodyMessage: errorMessage,
            },
            {
                action: NoDataActionType.error,
                inputSource: NoDataSourceType.chartCard,
                image: 'Empty-State-Error',
                header: errorHeader,
                bodyMessage: errorMessage,
            },
            {
                action: NoDataActionType.error,
                inputSource: NoDataSourceType.verySmallDataCard,
                image: '',
                header: errorHeader,
                bodyMessage: errorMessage,
            },
            {
                action: NoDataActionType.pageStart,
                inputSource: NoDataSourceType.listOfEntities,
                image: 'empty_table_data_img',
                header: noResult,
                bodyMessage: bodyDynamicText,
            },

            {
                action: NoDataActionType.lock,
                inputSource: NoDataSourceType.table,
                image: 'empty_state_permission_issue_img',
                header: loockHeader,
                bodyMessage: lockMessage,
            },
            {
                action: NoDataActionType.lock,
                inputSource: NoDataSourceType.largeDataCard,
                image: 'empty_state_permission_issue_img',
                header: loockHeader,
                bodyMessage: lockMessage,
            },
            {
                action: NoDataActionType.lock,
                inputSource: NoDataSourceType.smallDataCard,
                image: 'empty_state_permission_issue_img',
                header: loockHeader,
                bodyMessage: lockMessage,
            },
            {
                action: NoDataActionType.lock,
                inputSource: NoDataSourceType.chartCard,
                image: 'empty_state_permission_issue_img',
                header: loockHeader,
                bodyMessage: lockMessage,
            },
            {
                action: NoDataActionType.lock,
                inputSource: NoDataSourceType.verySmallDataCard,
                image: '',
                header: loockHeader,
                bodyMessage: lockMessage,
            },
        ];

        if (this.noDataType) {
            if (this.noDataType.wrapInACard) {
                this.cardStyle = 'no-data-card-area-with-card';
            }

            this.showTitle = this.noDataType.showTitle;
            this.componentTitle = this.noDataType.componentTitle;
            let isVerySmallCard =
                this.noDataType.inputSource === NoDataSourceType.verySmallDataCard ? true : false;
            this.showImage = !isVerySmallCard;
            if (isVerySmallCard) {
                this.noDataHeaderMessage = 'no-data-header-message-smallcard';
            }

            noDataCategories = this.noDataTypeList.filter(
                (item) => item.action === this.noDataType.action
            );

            noDataInfo = noDataCategories.find(
                (item) => item.inputSource === this.noDataType.inputSource
            );

            if (noDataInfo) {
                this.logoPlaceholderPath = this.logoPlaceholderMain + noDataInfo.image + '.png';
                this.headerMessage = noDataInfo.header.replace(
                    '$[replaceTextHeader]',
                    this.noDataType.searchTerm
                );
                if (this.noDataType.action === NoDataActionType.emptySelect) {
                    this.bodyMessage = noDataInfo.bodyMessage.map((item) => {
                        if (this.reusableFunctions.startsWithVowel(this.noDataType.searchTerm)) {
                            item = item.replace(' a ', ' an ');
                        }
                        return item
                            .replace('$[replaceTextHeader]', this.noDataType.searchTerm)
                            .replace('$[replaceTextBody]', this.noDataType.componentTitle);
                    });
                } else {
                    this.bodyMessage = noDataInfo.bodyMessage.map((item) =>
                        item.replace('$[replaceTextBody]', this.noDataType.componentTitle)
                    );
                }
            } else {
                this.logoPlaceholderPath = this.logoPlaceholderMain + 'empty_table_data_img.png';
                this.headerMessage = noData;
                this.bodyMessage = bodyDynamicText.map((item) =>
                    item.replace('$[replaceTextBody]', this.noDataType.componentTitle)
                );
            }
        } else {
            this.logoPlaceholderPath = this.logoPlaceholderMain + 'empty_table_data_img.png';
            this.headerMessage = noData;
            this.bodyMessage = message;
        }
        this.setMessageAreaStyles();
    }

    setMessageAreaStyles() {
        let noDataContainer = document.getElementById(this.cardStyle);
        if (noDataContainer) {
            let parentElement = noDataContainer.parentElement;
            parentElement.style.marginLeft = 'auto';
            parentElement.style.marginRight = 'auto';
            parentElement.style.marginTop = 'auto';
            parentElement.style.marginBottom = 'auto';
        }

        let superParentCollection = document.getElementsByTagName('no-data-screen');
        if (superParentCollection) {
            for (let parent of Array.from(superParentCollection)) {
                parent.parentElement.style.marginLeft = '2px';
                parent.parentElement.style.marginRight = '2px';
            }
        }
    }
}
